<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="poste" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.poste" placeholder="" name="poste" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Date<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="nbcp" class="font-light" >Numéro de compte<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nbcp" placeholder="" name="nbcp" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="motivation" class="font-light" >Motivation<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.motivation" placeholder="" name="motivation" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                    <p class="text-gray-700 mb-4 text-2xl text-right">Abidjan, le xxxxxxxxxxxx</p>
                    <p class="text-gray-700 mb-4 text-2xl">Reference…………………….</p>

                    <div class="flex justify-end mt-24 mb-24">
                        <p class="text-gray-700 mb-4 text-2xl mr-10 font-bold">
                            A<br>
                            Monsieur le Directeur Général<br>
                            BANK NAME
                        </p>
                    </div>

                    <h2 class="text-gray-700 mb-16 text-2xl"><span class="font-bold">Objet</span>: Notification de fin de contrat</h2>

                    <div class="mb-4">
                        <p class="text-gray-700 mb-6 text-2xl">
                            Madame/Monsieur le Directeur General,
                        </p>
                        <p class="text-gray-700 mb-6 text-2xl">
                            Par la présente, nous vous informons que <span class="font-bold">{{ form.nom ?? "TITLE NAME" }}</span>, précédemment <span class="font-bold">{{ form.poste ?? "POSITION" }}</span> au sein de notre Université, titulaire du numéro de compte <span class="font-bold">{{ form.nbcp ?? "ACCOUNT NUMBER" }}</span> domicilié dans vos livres, ne fait plus partie de notre personnel dépuis le <span class="font-bold">{{ form.startDate ?? "DATE" }}</span> suite à <span class="font-bold">{{ form.motivation ?? "MOTIVE" }}</span>.
                        </p>
                        <p class="text-gray-700 mb-6 text-2xl">
                            Le solde de tout compte vous a été transféré.
                        </p>
                        <p class="text-gray-700 mb-20 text-2xl">
                            Par conséquent, nous vous adressons ce courrier pour servir et valoir ce que de droit.
                        </p>
                    </div>

                    <div class="text-right text-2xl">
                        <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "NotifFinContrat",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                poste: null,
                startDate: null,
                nbcp: null,
                motivation: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.poste = null;
            this.form.startDate = null;
            this.form.nbcp = null;
            this.form.motivation = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":23,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>